module.exports = __webpack_public_path__ + "files/03a92443691005553b1a73f70b319f61.svg";